"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trustedDeviceRenameSchema = exports.mfaOverrideSchema = exports.mfaVerifySchema = exports.resetPasswordSchema = exports.refreshSchema = exports.loginSchema = exports.loginCredentialsSchema = exports.LOGIN_IDENTIFIER_REFINE_MESSAGE = exports.assignRoleToUserSchema = exports.updateUserSchema = exports.createUserSchema = void 0;
exports.exactlyOneLoginIdentifier = exactlyOneLoginIdentifier;
const zod_1 = require("zod");
// Mirrors core/authentication/password.service.ts's policy regex —
// duplicated deliberately (contracts must not depend on backend), kept
// in sync by convention: any policy change updates both.
const PASSWORD_POLICY_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;
exports.createUserSchema = zod_1.z.object({
    email: zod_1.z.string().email(),
    password: zod_1.z.string().regex(PASSWORD_POLICY_REGEX, 'Password does not meet the complexity policy'),
    firstName: zod_1.z.string().min(1).max(100),
    lastName: zod_1.z.string().min(1).max(100),
    employeeCode: zod_1.z.string().max(50).optional(),
    designation: zod_1.z.string().max(100).optional(),
    branchId: zod_1.z.string().uuid().optional(),
    departmentId: zod_1.z.string().uuid().optional(),
    joiningDate: zod_1.z.coerce.date().optional(),
});
exports.updateUserSchema = exports.createUserSchema
    .omit({ email: true, password: true })
    .partial();
exports.assignRoleToUserSchema = zod_1.z.object({
    roleIds: zod_1.z.array(zod_1.z.string().uuid()).min(1),
});
// Login flow overhaul — accepts either Email or Employee Code as the
// identifier, never both. The frontend collects this as a single "Email
// or Employee Code" field and dispatches it to whichever key applies
// client-side; the backend enforces exactly one is present.
//
// Exposed as an un-refined ZodObject (`loginCredentialsSchema`) too,
// alongside the shared predicate/message: `auth.routes.ts` needs to
// `.extend({ tenantCode })` this shape before applying the xor check,
// and `.extend()` only exists on a plain ZodObject — a `.refine()`
// result (ZodEffects) does not have it.
function exactlyOneLoginIdentifier(data) {
    return Boolean(data.email) !== Boolean(data.employeeCode);
}
exports.LOGIN_IDENTIFIER_REFINE_MESSAGE = 'Provide exactly one of email or employeeCode';
exports.loginCredentialsSchema = zod_1.z.object({
    email: zod_1.z.string().email().optional(),
    employeeCode: zod_1.z.string().min(1).optional(),
    password: zod_1.z.string().min(1),
});
exports.loginSchema = exports.loginCredentialsSchema.refine(exactlyOneLoginIdentifier, {
    message: exports.LOGIN_IDENTIFIER_REFINE_MESSAGE,
});
// Login flow overhaul — redeems a refresh token for a new access/refresh
// pair. See core/authentication/jwt.service.ts's verifyRefreshToken().
exports.refreshSchema = zod_1.z.object({
    refreshToken: zod_1.z.string().min(1),
});
exports.resetPasswordSchema = zod_1.z.object({
    newPassword: zod_1.z.string().regex(PASSWORD_POLICY_REGEX, 'Password does not meet the complexity policy'),
});
// Phase S1 — completes login after AuthService.login() returns an MFA
// challenge. Either a 6-digit OTP or a recovery code, never both.
exports.mfaVerifySchema = zod_1.z.object({
    mfaChallengeToken: zod_1.z.string().min(1),
    code: zod_1.z.string().regex(/^\d{6}$/).optional(),
    recoveryCode: zod_1.z.string().min(1).optional(),
    rememberDevice: zod_1.z.boolean().optional(),
}).refine((data) => Boolean(data.code) !== Boolean(data.recoveryCode), {
    message: 'Provide exactly one of code or recoveryCode',
});
exports.mfaOverrideSchema = zod_1.z.object({
    required: zod_1.z.boolean().nullable(),
});
exports.trustedDeviceRenameSchema = zod_1.z.object({
    deviceLabel: zod_1.z.string().min(1).max(150),
});
//# sourceMappingURL=user.schema.js.map